import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToSection } from '../utils/scrollToSection';

/**
 * Handles smooth-scrolling to in-page sections (e.g. "/#services") on route
 * change, and resets scroll to top on plain route changes with no hash.
 * Mounted once at the top of the router so it reacts to every navigation.
 */
export default function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      // Small delay lets the destination page's sections mount first.
      const timer = setTimeout(() => {
        scrollToSection(id);
      }, 80);
      return () => clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
    return undefined;
  }, [hash, pathname]);

  return null;
}
